if (typeof(window.horizontalImageList) === 'undefined') {
  window.horizontalImageList = {
    config: {
      CLASS_SELECTOR: '.horizontal-image-list--scrollable-small',
    },
    init: () => {
      window.addEventListener('resize', window.horizontalImageList.refresh);
      document.addEventListener("DOMContentLoaded", function () {
        window.horizontalImageList.refresh();
      });
    },
    create: (el) => {
      if (!el) {
        return;
      }

      let flkty = Flickity.data(el);
      
      if (!flkty) {
        flkty = new Flickity(el, {
          cellAlign: 'center',
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
        });
      } else {
        flkty.resize();
      }
      
    },
    destroy: (el) => {
      if (!el) {
        return;
      }

      const flkty = Flickity.data(el);
      flkty.destroy();
    },
    refresh: () => {
      const elements = document.querySelectorAll(window.horizontalImageList.config.CLASS_SELECTOR);

      elements.forEach(function (el) {
        // If window width is less than 768px
        if (window.innerWidth <= 768) {
          // Initialize Flickity
          window.horizontalImageList.create(el);
        } else {
          // Destroy Flickity instance if it exists
          window.horizontalImageList.destroy(el);
        }
      });
    },
  };
  
  window.horizontalImageList.init();
}